import React from "react";
import { EditIcon, CopyIcon } from "../../../assets";
import classnames from "classnames";
import { FlightInformation, RountTrip } from "../../../components";
import { DateHelper, renderRecordValue } from "../../../utils";
import { STATUSES_STYLING } from "../../../constants/styles/statuses";
import {
  getRiderActualHeightForBariaticVehicleType,
  getRiderActualWeightForBariaticVehicleType,
  getUberDriverWaitMinutesForDetails,
  selectHOAdminStatus,
} from "../../../utils/helpers";
import styles from "./index.module.css";
import { vehicleOptionsDictionary } from "../../../dictionaries";
import { Popover, Tag } from "antd";
import { OverNight } from "../../../components/common/OverNight/OverNight";
import { rescheduleMessage, RIDE_STATUSES, URLS, UBER_TEXT } from "../../../constants/constants";

import { RescheduleRideIcon } from "../../../components/common/RescheduleRideIcon/RescheduleRideIcon";
import classNames from "classnames";
import { RideHelper } from "../../../utils/RideHelper";
import { AdditionalSeat } from "../../../components/common/AdditionalSeat/AdditionalSeat";
import { UberHealthTag } from "../../../components/common/UberHealthTag/UberHealthTag";
import { RideDriverPopover } from "../../../components/common/RideDriverPopover/RideDriverPopover";
import reRequestIcon from "../../../assets/svgs/reRequestIcon.svg";
import redeemNowIcon from "../../../assets/svgs/redeemNowIcon.svg";
import {
  shouldShowFlexibleRedeemButton,
} from "../../../utils/flexibleUberRedeem";

export const renderColumns = ({
  handleCopyRide,
  handleEditRide,
  handleRescheduleRide,
  handleOpenRedeemModal,
  navigate,
  user,
  isViewDashboardMode
}) => {
  return [
    (user?.permissions?.orgList && {
      title: "Locations",
      dataIndex: "healthOrganizationName",
      key: "healthOrganizationName",
      width: 180,
      render: (text) => (
        <div
          className={classnames({
            [styles.organizationCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(text?.split("_").join(" "))}
        </div>
      ),
    }),
    {
      title: "Ride ID",
      dataIndex: "seqId",
      key: "seqId",
      render: (text, record) => (
        <div
          className={classnames({
            [styles.draftIdCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          <span className={styles.rideIdInline}>
            {record?.flightInfo ? (
              <Popover
                content={<FlightInformation flightInfo={record?.flightInfo} />}
                placement="topLeft"
                getPopupContainer={() => document.querySelector(".ant-table")}
              >
                <span style={{ color: "blue", textDecorationLine: "underline" }}>
                  {renderRecordValue(text)}
                </span>
              </Popover>
            ) : (
              renderRecordValue(text)
            )}
            <RideDriverPopover record={record} />
          </span>

          {record?.isReRequested && (
            <div className={styles.uberNoShowCell}>
              <Tag className={styles.uberReRequestedTag}>
                Re-Requested
              </Tag>
            </div>
          )}
          <br />

          <div className={styles.displayIcons}>
            <OverNight record={record} />
            <AdditionalSeat record={record} />
          </div>

          <div className={styles.dflex}>
            <RountTrip record={record} />
            {(record?.status === RIDE_STATUSES.RESCHEDULED || record?.rescheduledFrom) && (
              <RescheduleRideIcon />
            )}
          </div>
        </div>


      ),
      width: 155,
    },

    {
      title: "Rider Name",
      dataIndex: "rider",
      key: "rider",
      width: 150,
      render: (text) => (
        <div
          className={classnames({
            [styles.riderCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(text)}
        </div>
      ),
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      key: "vehicleType",
      width: 250,
      render: (text, record) => (
        <>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
            })}
          >
            {renderRecordValue(vehicleOptionsDictionary[text])}
            {text === 'uberAmbulatoryRide' && <UberHealthTag />}

          </div>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
              [styles.actualWeight]: true,
            })}
          >
            {getRiderActualWeightForBariaticVehicleType(text, record)}
          </div>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
              [styles.actualWeight]: true,
            })}
          >
            {getRiderActualHeightForBariaticVehicleType(text, record)}
          </div>
        </>
      ),
    },
    {
      title: "Pickup Date",
      dataIndex: "pickUpDate",
      key: "pickUpDate",
      width: 200,
      render: (value) => (
        <div
          className={classnames({
            [styles.pickUpDateCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(value)}
        </div>
      ),
    },

    {
      title: "Date Created",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (text) => (
        <div
          className={classnames({
            [styles.dateCreatedCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(
            text && DateHelper.format(new Date(text), "M/dd/yyyy")
          )}
        </div>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
      width: 150,
      render: (text) => (
        <div
          className={classnames({
            [styles.createdByCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(text)}
        </div>
      ),
    },
    {
      title: "Ride Status",
      dataIndex: "readableStatus",
      key: "readableStatus",
      width: 220,
      render: (text, record) => {
        const driverWaitMins = getUberDriverWaitMinutesForDetails(record);
        const showNoShowDriverWait =
          record?.status === RIDE_STATUSES.UNABLE_TO_FULFILL &&
          driverWaitMins !== null &&
          !Number.isNaN(driverWaitMins);
        const isExpiredUberRide =
          record?.status === RIDE_STATUSES.EXPIRED &&
          record?.vehicleType === "uberAmbulatoryRide";
        const showDriverArrived = !!record?.rideCurrentAction;
        return (
          <div
            className={classnames({
              [STATUSES_STYLING[text]]: true,
            })}
          >
            {text.toLowerCase() === RIDE_STATUSES.RESCHEDULED.toLowerCase() ||
              (text.toLowerCase() === RIDE_STATUSES.ACCEPTED.toLowerCase() &&
                record?.rescheduledFrom) ? (
              <Popover
                content={`Rescheduled Ride`}
                placement="topLeft"
                overlayClassName={classNames({
                  [styles.overlay]: true,
                })}
                getPopupContainer={(trigger) => trigger}
              >
                <div>{renderRecordValue(selectHOAdminStatus(text))}</div>
              </Popover>
            ) : (
              <>
                {renderRecordValue(selectHOAdminStatus(text))}
                {showNoShowDriverWait && (
                  <div className={styles.noShowDriverWaitLine}>
                    {`No Show | Driver wait ${driverWaitMins} ${driverWaitMins === 1 ? "Min" : "Mins"
                      }`}
                  </div>
                )}
                {isExpiredUberRide && (
                  <div className={styles.noShowDriverWaitLine}>
                    {UBER_TEXT.RIDE_NOT_REDEEMED}
                  </div>
                )}
                {showDriverArrived && (
                  <div className={styles.driverArrivedCapsule}>Driver Arrived</div>
                )}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Recurring",
      Component: (
        <th>
          <div className={styles.cellValue} />
        </th>
      ),
      dataIndex: "actions",
      key: "actions",
      width: 120,
      render: (text, record) => {
        const isUberRide = record?.vehicleType === 'uberAmbulatoryRide';
        const hasIcon = record?.status === RIDE_STATUSES.UNABLE_TO_FULFILL;
        const showReRequestIcon = hasIcon && !record?.isReRequested;
        const hasIndex = !!record?.recurringRideIndex;
        const showRedeemIcon = shouldShowFlexibleRedeemButton(
          record,
          user?.role,
          isViewDashboardMode,
        );

        return (
          <>
            <div
              className={classnames({
                [styles.recurringInfo]: true,
                [styles.recurringCellValue]: true,
                [styles.lastRide]: record.isLastRecurring,
              })}
            >
              {hasIndex
                ? renderRecordValue(record.recurringRideIndex)
                : !hasIcon
                  ? "-"
                  : null}
            </div>
            <div
              className={classnames({
                [styles.actionsColumn]: true,
                [styles.cellValue]: true,
              })}
            >
              <div
                className={classnames({
                  [styles.actions]: true,
                  [styles.actionsWithReRequest]: showReRequestIcon,
                  [styles.actionsWithRedeem]: showRedeemIcon,
                })}
              >
                {
                  !isUberRide &&
                  (
                    <EditIcon
                      width={25}
                      height={25}
                      className={styles.actionsIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditRide(record?.id, record?.isRecurring);
                      }}
                    />
                  )
                }


                {showReRequestIcon && (
                  <span
                    className={styles.reRequestIconWrapper}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate.push(
                        URLS.UBER_RESCHEDULE_RIDE.replace(":id", record.id),
                      );
                    }}
                    title={UBER_TEXT.TOOLTIP_REREQUEST_NEW_UBER_RIDE}
                  >
                    <img
                      src={reRequestIcon}
                      alt="Re-request Uber ride"
                      width={21}
                      height={21}
                      className={classnames(styles.reRequestIcon, styles.actionsIcon)}
                    />
                  </span>
                )}

                {record?.status === RIDE_STATUSES.ACCEPTED && !isUberRide && (
                  <span
                    className={classnames(styles.icon_container)}
                    onClick={(e) => {
                      const isValidForReschedule = RideHelper.isRideValidForReschedule(record);
                      e.stopPropagation();
                      if (isValidForReschedule) {

                        handleRescheduleRide(record?.id, record?.isRecurring);
                      }
                    }}
                  >
                    <RescheduleRideIcon
                      width={22}
                      height={22}
                      tooltip={
                        RideHelper.isRideValidForReschedule(record)
                          ? "Reschedule Ride"
                          : rescheduleMessage
                      }
                      fill={
                        RideHelper.isRideValidForReschedule(record)
                          ? "#018100"
                          : "#01810050"
                      }
                      showText={false}
                    />
                  </span>
                )}

                {showRedeemIcon && (
                  <Popover
                    content={UBER_TEXT.REDEEM_NOW}
                    trigger="hover"
                    overlayClassName={styles.redeemTooltipOverlay}
                    getPopupContainer={(trigger) => document.body}
                  >
                    <span
                      className={styles.redeemIconWrapper}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenRedeemModal(record);
                      }}
                    >
                      <img
                        src={redeemNowIcon}
                        alt={UBER_TEXT.REDEEM_NOW}
                        className={styles.redeemIcon}
                      />
                    </span>
                  </Popover>
                )}

                <CopyIcon
                  backRectFill="#E1F4D3"
                  frontPathFill="#1C452B"
                  backPathFill="#1C452B"
                  width={21}
                  height={21}
                  className={classnames({
                    [styles.actionsIcon]: true,
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyRide(record);
                  }}
                />
              </div>
            </div>
          </>
        );
      },
    },
  ].filter(Boolean);
};
